import { Pipe, PipeTransform } from '@angular/core';

export interface PhoneFormatOptions {
  includeCountryCode?: boolean; // prefix +1 / +55 in output
}

@Pipe({
  name: 'phoneFormat',
  standalone: true,
  pure: true,
})
export class PhoneFormatPipe implements PipeTransform {
  transform(
    value: string | number | null | undefined,
    countryOrCC:  string | '1' | '55',
    opts?: PhoneFormatOptions
  ): string {
    const includeCC = !!opts?.includeCountryCode;
    const digits = this.onlyDigits(String(value ?? ''));

    const country =
      countryOrCC === '1' || countryOrCC === '55'
        ? countryOrCC === '1'
          ? 'US'
          : 'BR'
        : countryOrCC;

    if (!digits) return '';

    const local = this.stripCountryCode(digits, country);
    const formattedLocal =
      country === 'US' ? this.formatUS(local) : this.formatBR(local);

    return includeCC
      ? country === 'US'
        ? `+1 ${formattedLocal}`
        : `+55 ${formattedLocal}`
      : formattedLocal;
  }

  // ------- helpers -------
  private onlyDigits(s: string): string {
    return s.replace(/\D+/g, '');
  }

  private stripCountryCode(d: string, country: string): string {
    if (country === 'US') {
      // If user sent 11 digits starting with 1, remove it
      return d.startsWith('1') && d.length >= 11 ? d.slice(1) : d;
    }
    // BR: remove leading 55 if present
    return d.startsWith('55') && d.length >= 12 ? d.slice(2) : d;
  }

  // US: (AAA) BBB-CCCC (cap to 10 digits)
  private formatUS(localAny: string): string {
    const s = localAny.slice(0, 10);
    if (s.length <= 0) return '';
    if (s.length <= 3) return `(${s}`;
    if (s.length <= 6) return `(${s.slice(0, 3)}) ${s.slice(3)}`;
    return `(${s.slice(0, 3)}) ${s.slice(3, 6)}-${s.slice(6)}`;
  }

  // BR: landline 10 -> (AA) XXXX-XXXX | mobile 11 -> (AA) 9XXXX-XXXX
  private formatBR(localAny: string): string {
    const s = localAny.slice(0, 11);
    if (s.length <= 0) return '';
    if (s.length <= 2) return `(${s}`;

    const ddd = s.slice(0, 2);
    const rest = s.slice(2);

    // 8 digits (landline body)
    if (rest.length <= 4) return `(${ddd}) ${rest}`;
    if (rest.length <= 8)
      return `(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;

    // 9-digit mobile body (most cases)
    const r = rest.slice(0, 9); // ensure 9 max
    if (r.length <= 5) return `(${ddd}) ${r}`;
    return `(${ddd}) ${r.slice(0, 5)}-${r.slice(5)}`;
  }
}
